<template>
    <div class="base-multiple-item-picker d-flex justify-content-center align-items-stretch">
        <div
            v-for="option in options" 
            :key="option.value"
            @click="handleSelection(option.value)" 
            class="px-3 py-2 item-picker-element"
            :class="value.includes(option.value) ? 'shadow selected' : 'shadow-sm'"
        >
            <div class="d-flex justify-content-between align-items-start">
                <h6>{{ option.title }}</h6>
                <transition name="fade-fast">
                    <b-icon 
                        v-if="value.includes(option.value)" 
                        icon="check" 
                        variant="white"
                        class="bg-success m-0 rounded-circle"
                        style="height: 16px; width: 16px;"
                    ></b-icon>
                </transition>
            </div>
            <p class="text-muted small mb-0">{{ option.text }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseMultipleItemPicker',
    props: {
        value: Array,
        options: {
            type: Array,
            default: function() {
                return [
                    {
                        value: 'one',
                        title: 'First Thing',
                        text: 'This is some longer text about this option to provide more details.'
                    },{
                        value: 'two',
                        title: 'Second Thing',
                        text: 'This is some longer text about this option to provide more details.'
                    },{
                        value: 'three',
                        title: 'Third Thing',
                        text: 'This is some longer text about this option to provide more details.'
                    },{
                        value: 'four',
                        title: 'Fourth Thing',
                        text: 'This is some longer text about this option to provide more details and more really long text here that wraps to the next line for sure I think maybe.'
                    },{
                        value: 'five',
                        title: 'Fourth Thing',
                        text: 'This is some longer text about this option to provide more details and more really long text here that wraps to the next line for sure I think maybe.'
                    },{
                        value: 'six',
                        title: 'Fourth Thing',
                        text: 'This is some longer text about this option to provide more details and more really long text here that wraps to the next line for sure I think maybe.'
                    }
                ]
            }
        }
    },
    data: function() {
        return {
            selection: [],   // start with an empty array
        }
    },
    computed: {
        hasSelection: function() {
            if (this.selection.length < 1) {
                return false;
            } else {
                return true;
            }
        },
        localValue: function() {
            // need this to handle the null case and just return empty array if value prop is null
            return this.value ? this.value : [];
        },
        selectedOptions: function() {
            // filters our list of all possible options for ones that are selected
            return this.options.filter(option => this.value.includes(option.value)); 
        },
        selectedTrackerObj: function() {
            // local object to track what is currently checked/not-checked based on options array and value prop array
            var localObj = {};
            this.options.forEach(option => {
                localObj['option.value'] = this.value.includes(option.value)
            });
            return localObj;
        },

    },
    methods: {
        handleSelection: function(clickedValue) {
            if (this.value.includes(clickedValue)) {
                // if the value is already selected, then remove it (filter it out, easier, and doesn't mutate original)
                var filteredValueArray = this.value.filter(val => val !== clickedValue);  // pass all elements that don't match clicked value
                this.selection = filteredValueArray;
                this.$emit('input', filteredValueArray);
            } else {
                // if we're here, then the value was not already clicked, so we should copy localValue array, add new item and emit event
                var addedValueArray = [...this.value, clickedValue];   // this makes new array using values from this.value, and adds new value
                this.selection = addedValueArray;
                this.$emit('input', addedValueArray);
            }
        }
    }
}
</script>

<style scoped>
    .item-picker-element {
        border: 3px solid var(--secondary-light);
        border-radius: 0.5rem;
        background-color: #fff;
        cursor: pointer;
        transition: 0.15s ease-in-out;
        max-width: 300px;
        margin-right: 1rem;
    }
    .item-picker-element:last-child {
        margin-right: 0;
    }
    .item-picker-element.selected {
        border-color: var(--success);
    }
</style>